// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  updateProductAndGetCartOrNotify,
  selectOneProductErrors,
  type DecoratedProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import ProductErrorItem from './components/ProductErrorItem';
import ProductItem from './components/ProductItem';

import { DurationRow } from './components/Rows';
import type { GandiFormSelectOption } from './types';

type Props = {
  product: DecoratedProduct,
};

const DURATIONS = [1, 3, 5];

function Tmch({ product }: Props) {
  const { id, unitPrice, isWorking, payload } = product;
  const translator = useTranslator();
  const { __ } = translator;
  const dispatch = useDispatch();

  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, {
      productId: product.id,
    }),
  );

  const label = payload.label || '';
  const detail = payload.mark_name;

  if (productErrors.length > 0)
    return (
      <ProductErrorItem
        key={`${product.id}-error-row`}
        label={label}
        detail={detail}
        productId={product.id}
        errors={productErrors}
      />
    );

  function handleDurationChange(selectedOption: GandiFormSelectOption<string>) {
    const newPayload = {
      ...product.payload,
      duration: parseInt(selectedOption.value, 10),
    };

    dispatch(updateProductAndGetCartOrNotify(__, product.id, newPayload));
  }

  return (
    <ProductItem
      label={payload.label || ''}
      detail={payload.mark_name}
      productId={id}
      footer={
        <DurationRow
          productId={product.id}
          value={product.payload.duration || 1}
          // $FlowFixMe[incompatible-type-arg] - number is number|string
          onChange={handleDurationChange}
          values={DURATIONS}
          disabledOption={!!isWorking}
          total={unitPrice}
        />
      }
    />
  );
}

export default (React.memo<Props>(Tmch): React.ComponentType<Props>);
